<template>
  <v-hover v-slot:default="{ hover }">
    <v-row
      align="center"
      justify="center"
    >
      <v-card
        :height="sizeAndHeight"
        :width="sizeAndHeight"
        flat
        class="transparent"
      >
        <v-row justify="center">
          <avatar
            :image-url="currentImageURL"
            :display-name="getAuthUser.displayName"
            :size="sizeAndHeight"
            :font="80"
          />

          <v-overlay
            class="the-overlay"
            :absolute="true"
            :value="hover"
          >
            <file-upload
              :on-change="onFileChange"
            >
              <template #content>
                <v-btn
                  icon
                  fab
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </file-upload>
            <v-btn
              icon
              fab
              @click="onRemovePicture"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </v-overlay>
        </v-row>
      </v-card>
    </v-row>
  </v-hover>
</template>
<style>
  .the-overlay {
    border-radius: 50%;
  }
</style>
<script>
import { mapGetters } from 'vuex'
import FileUpload from "../Common/FileUpload"
import Avatar from "../Avatar"

export default {
  components: {
    Avatar,
    FileUpload
  },
  computed: {
    ...mapGetters([ 'getAuthUser' ])
  },
  mounted() {
    this.currentImageURL = this.getAuthUser.photoURL
  },
  methods: {
    onRemovePicture() {
      this.$emit('select', null)
      this.currentImageURL = null
    },
    onFileChange(file) {
      const url = URL.createObjectURL(file)

      this.currentImageURL = url
      this.$emit('select', file)
    },
  },
  data() {
    return {
      sizeAndHeight: 200,
      currentImageURL: null,
      forceOverlay: false
    }
  }
}
</script>

